var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide",style:(_vm.getBorderColor)},[_c('div',{staticClass:"iconfont",style:(_vm.getMainColor)},[_vm._v(_vm._s(`\ue6aa`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }